// extracted by mini-css-extract-plugin
module.exports = {"grid":"providers-grid_grid__22sRf"};